import { render, staticRenderFns } from "./BottomSheetTopicNavigation.vue?vue&type=template&id=d8e60e80&scoped=true&"
import script from "./BottomSheetTopicNavigation.vue?vue&type=script&lang=js&"
export * from "./BottomSheetTopicNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetTopicNavigation.vue?vue&type=style&index=0&id=d8e60e80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e60e80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
